import $ from 'jquery';

$(function () {
    $('.nav-link[href="' + location.pathname + '"]').addClass('active');
});